export default __webpack_public_path__ + "static/media/edit_image.9d6781dc.svg";